module.exports = __webpack_public_path__ + "img/magento-logo.660d253b.svg";